import React from "react";
import { useEffect, useState } from "react";
import { getTestResults, consumeRetakeCourse } from "../../services/api";
import { useNavigate } from "react-router-dom";
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import { getPaymentIntent } from "../../services/api";
import { downloadPdf } from "../../services/api";
import Retakecheckout from './Retakecheckout';
import Modal from "react-modal";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const CourseResultCard = (props)=>{
	const [tests , setTests] = useState([]);
	const [isLoadingTests, setIsLoadingTests] = useState(true);
	const [clientSecret, setClientSecret] = useState("");
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isloader , setIsLoader] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const navigate= useNavigate();
	useEffect(()=>{	
		getResults();
	},[]);

	const generatePdf =async()=>{
		var user_id = sessionStorage.getItem("user_id");
		var token  = sessionStorage.getItem("token");
		const pdfBlob = await downloadPdf(token, user_id);
		const blob = new Blob([pdfBlob.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Completion_Certificate.pdf'; 
        link.click();
	}

	const handleExam=async()=>{
		var course_status = JSON.parse(sessionStorage.getItem("user")).course_status;
		if(course_status != '2'){
			try {
				const token = sessionStorage.getItem("token");
				const user_id = sessionStorage.getItem("user_id");
				const response = await consumeRetakeCourse(token, user_id);
				// Update session storage with all user statuses
				if(response.data.data.user){
					sessionStorage.setItem("user", JSON.stringify(response.data.data.user));
				}
				navigate('/course/home');
			} catch (error) {
				console.error('Error fetching user data:', error);
				// Navigate anyway even if API call fails
				navigate('/course/home');
			}
		}
		else{
			sessionStorage.setItem("examAllow",true);
			navigate('/course/take-exam')
		}
	}

	// Use purchased retake flow: skip consumeRetakeCourse API call, just navigate.
	const handleUseRetake = () => {
		const course_status = JSON.parse(sessionStorage.getItem("user")).course_status;
		if (course_status !== '2') {
			navigate('/course/home');
		} else {
			sessionStorage.setItem("examAllow", true);
			navigate('/course/take-exam');
		}
	};
	const getResults=async()=>{
		setIsLoadingTests(true);
		try {
			const token = sessionStorage.getItem("token");
			const userId = sessionStorage.getItem("user_id");
			const response = await getTestResults(token, userId);
			const results = response?.data?.results;
			setTests(Array.isArray(results) ? results : []);
		} catch (error) {
			console.error("[CourseResultCard] Error fetching test results:", error);
			setTests([]);
		} finally {
			setIsLoadingTests(false);
		}
	}

	const readcourse =()=>{
		props.setStartCourse(false);
		navigate('/course/home');
	}

	const handleNext = async (e) => {
		setIsLoading(true);  // Set loading to true before the request
		e.preventDefault();
		const response = await getPaymentIntent();
		setClientSecret(response.data);
		setIsModalOpen(true);
		setIsLoading(false);  // Set loading to true before the request
	  };
	return (
		<>
			<div className="container mt-4">
				<div className="row mt-4">
					<div className="col-12 d-flex mt-4 justify-content-center">
						<h1 className="course-result-heading">Course Results</h1>
					</div>
					<div className="col-md-6 d-flex mt-4 justify-content-center ">
						<h1 className="course-status-text">Course Status: </h1>
					<span className={`badge ${JSON.parse(sessionStorage.getItem("user")).course_status === '2'?'bg-success':'bg-primary'} alerting`}>{JSON.parse(sessionStorage.getItem("user")).course_status === '2'?'Completed':'Inprogress'}</span>
					</div>
					<div className="col-md-6 d-flex mt-4 justify-content-center ">
						<h1 className="course-status-text ">Test Status: </h1>
						<span className={`badge ${JSON.parse(sessionStorage.getItem("user")).test_status === '1'?'bg-success':'bg-primary'} alerting`}>{JSON.parse(sessionStorage.getItem("user")).test_status === '1'?'Completed':'Incomplete'}</span>
					</div>
				</div>
				<div className="row mt-4">
					<div className="col-12 table-result-card mt-4">
					<table className="table mt-4">
						<thead>
							<tr>
							<th scope="col">#</th>
							<th scope="col">Type of Test</th>
							<th scope="col">Remarks</th>
							<th scope="col">Date Taken</th>
							<th scope="col">Result</th>
							</tr>
						</thead>
						<tbody>
							{isLoadingTests ? (
								<tr>
									<td colSpan={5}>
										<span className="loading-text-spinner">Loading .....</span>
									</td>
								</tr>
							) : tests.length > 0 ? (
								<>
									{tests.map((test,index)=>
									<tr key={index}>
									<td scope="row">{index+1}</td>
									<td>
										{index === 0 ? 'Original' : index === 1 ? 'Free Retake' : 'Purchased Retake'}
									</td>
									<td>{test.test_title === '0' ? 'Test Failed':'Verification Failed'}</td>
									<td>{test.date_taken}</td>
									<td><span className={`badge ${test.result === '0' ? 'bg-danger':'bg-success'}`}>{test.result === '0' ? 'Fail':'Passed'}</span></td>
									</tr>
								)}
								</>
							) : (
								<tr>
									<td colSpan={5} className="text-center text-muted py-3">
										No Tests taken yet
									</td>
								</tr>
							)}
						</tbody>
					</table>
					
					</div>
				</div>
				<div className="row mt-4">
					<div className="col-12 mt-4">
						<h1 className="course-result-heading">Next Step</h1>
					</div>
					<div className="col-12 mt-4">
						{(() => {
							const user = JSON.parse(sessionStorage.getItem('user') || '{}');
							const retakeStatus = String(user.retake_status || '0');
							const retakePermission = String(user.retake_permission || '0');
							const testStatus = String(user.test_status || '0');
							const course_status = String(user.course_status || '0');
							const free_retake = String(user.free_retake || '0');
							
							// Debug logging
							console.log('[CourseResultCard] User values:', {
								retake_status: retakeStatus,
								retake_permission: retakePermission,
								test_status: testStatus
							});
							
							return (
								<>
									{retakeStatus === '1' && testStatus !== '1' && free_retake === '0' && (
										<button className="call-to-action-btn ms-4" onClick={handleExam}>
											Take Free Retake
										</button>
									)}
									{retakePermission === '1' && testStatus !== '1' && course_status !== '2' && (
										<button onClick={handleUseRetake}  className="call-to-action-btn ms-4">
											Continue Course
										</button>
									)}
									{retakePermission === '1' && testStatus !== '1' && course_status == '2' && free_retake === '1' && (
										<button onClick={handleUseRetake}  className="call-to-action-btn ms-4">
											Use Retake
										</button>
									)}
									{retakeStatus > '1' && retakePermission === '0' && testStatus !== '1' && (
										<button onClick={handleNext} className="call-to-action-btn ms-4" style={{minWidth: '185px'}}>
											{isLoading ? (
												<span>Loading...</span>
											) : (
												'Purchase Retake'
											)}
										</button>
									)}
								</>
							);
						})()}
						{JSON.parse(sessionStorage.getItem('user')).test_status === '1'?<button onClick={generatePdf} className="download-pdf-btn ms-4">Download Certificate</button>:<></>}
						<button onClick={readcourse} className="download-pdf-btn ms-4" >Review Completed Chapters</button>
					</div>
				</div>
				<div className="row  mt-4">
				
			</div>
			</div>
			<Modal
				isOpen={isModalOpen}
				onRequestClose={() => setIsModalOpen(false)}
				className="modal-class"
				overlayClassName="overlay-class"
				ariaHideApp={false}
			>
				<div className="modal-header">
				<h2>Complete Your Payment</h2>
				<button onClick={() => setIsModalOpen(false)} className="close-btn">
					&times;
				</button>
				</div>
				<div className="modal-body">
				{clientSecret ? (
					<Elements stripe={stripePromise} options={{ clientSecret }}>
					<Retakecheckout
						clientSecret={clientSecret}
						setIsLoader={setIsLoader}
					/>
					</Elements>
				) : (
					<p>Loading payment details...</p>
				)}
				</div>
			</Modal>
		</>
	);
}
export default CourseResultCard;